import { NgModule } from '@angular/core';

import { NgxMaskModule } from 'ngx-mask';

const maskConfig = {
  validation: false,
};

@NgModule({
  imports: [NgxMaskModule.forRoot(maskConfig)],
  exports: [NgxMaskModule],
})
export class CustomNgxMaskModule {}
